var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seckill"},[_vm._v(" 秒杀模块 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }